// Cache współdzielony przez wszystkie instancje FpSvgIcon — trzymamy Promise, żeby równoległe mounty tej samej ikony
// korzystały z jednego requestu zamiast odpalać własny.
const svgTextCache = new Map<string, Promise<string>>();

export const fetchSvgText = (url: string): Promise<string> => {
  let cached = svgTextCache.get(url);
  if (!cached) {
    cached = fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(new Error(`HTTP ${r.status}`))))
      .catch((error) => {
        svgTextCache.delete(url);
        throw error;
      });
    svgTextCache.set(url, cached);
  }
  return cached;
};
